import { GlobalState } from '../states/global-state';
import { KycProps } from '../constants/kyc';
import { moment } from '../constants/lib';

type DataType = {
  bankId: string;
  brachId: string;
  birthDate: string;
  employerName: string;
  firstName: string;
  gender: string;
  govRelative: string;
  homeAddress: string;
  homeCity: string;
  homeCountry: string;
  homeInhabitPeriod: string;
  homePhoneNumber: string;
  homePostalCode: string;
  homeProvince: string;
  idNumber: string;
  idType: string;
  investInterest: string;
  investRegular: string;
  lastName: string;
  maritalStatus: string;
  nationality: string;
  natureOfBusiness: string;
  occupation: string;
  officeAddress: string;
  officeCity: string;
  officeCountry: string;
  officePhoneNumber: string;
  officePostalCode: string;
  officeProvince: string;
  settlementAccountName: string;
  settlementAccountNo: string;
  shareholder: string;
  taxId: string;
  totalIncomePa: string;
  typeOfAccount: string;
  workGov: string;
  birthPlace: string;
};

export default class KycPayload {
  data: DataType;
  notFound: string[];
  low: string[];
  required: string[];

  constructor(data) {
    this.data = { ...data };
    this.notFound = [];
    this.low = Object.values(KycProps);
    this.required = [
      'bankId',
      'branchId',
      'birthDate',
      'employerName',
      'firstName',
      'gender',
      'govRelative',
      'homeAddress',
      'homeCity',
      'homeCountry',
      'homeInhabitPeriod',
      'homePhoneNumber',
      'homePostalCode',
      'homeProvince',
      'idNumber',
      'idType',
      'investInterest',
      'investRegular',
      'lastName',
      'maritalStatus',
      'nationality',
      'natureOfBusiness',
      'occupation',
      'officeAddress',
      'officeCity',
      'officeCountry',
      'officePhoneNumber',
      'officePostalCode',
      'officeProvince',
      'settlementAccountName',
      'settlementAccountNo',
      'shareholder',
      'taxId',
      'totalIncomePa',
      'typeOfAccount',
      'workGov',
      'birthPlace',
    ];

    this.validate();
  }
  validate() {
    const loaded = GlobalState.kycLoad.value;
    const loadedSettlement = GlobalState.settlementLoad.value;
    const data = {} as DataType;

    //initialized
    this.low.forEach(item => {
      data[item] = undefined;
    });

    //fill data
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        //old
        if (!['', ' ', undefined, null].includes(loaded[key])) {
          data[key] = loaded[key];
        }
        //old
        if (!['', ' ', undefined, null].includes(loadedSettlement[key])) {
          data[key] = loadedSettlement[key];
        }
        //new , from form input
        if (!['', ' ', undefined, null].includes(this.data[key])) {
          data[key] = this.data[key];
        }
      }
    }

    if (data['totalChildren']) {
      data['totalChildren'] = Number(data['totalChildren']) || 0;
    }

    data.birthDate &&
      (data.birthDate = moment
        ? moment(data.birthDate).format('MMDDYYYY')
        : '');

    const notFound = [];
    this.required.forEach(item => {
      if (['', ' ', undefined, null].includes(data[item])) {
        notFound.push(item);
      }
    });

    // console.log(122, data);

    this.notFound = [...notFound];

    if (notFound.length) {
      console.log('notFound', this.notFound);
      throw new Error('required kyc data is not complete');
    }

    this.data = data as DataType;
  }
}
